export default __webpack_public_path__ + "static/media/axis-header.63efde28.webp";